import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-44dce8a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-muted" }, "Chargement des questions...", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-danger d-flex align-items-center mb-20" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle me-10 fs-20" }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Attention !"),
    /*#__PURE__*/_createTextVNode(" Une fois le quiz démarré, vous ne pouvez pas quitter cette page. Si vous fermez votre navigateur ou revenez en arrière, cette tentative sera perdue. ")
  ])
], -1))
const _hoisted_8 = { class: "fw-bold mb-0" }
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = { class: "badge bg-warning fs-12" }
const _hoisted_12 = {
  key: 0,
  class: "text-muted ms-2 small"
}
const _hoisted_13 = {
  key: 1,
  class: "text-muted ms-2 small"
}
const _hoisted_14 = {
  key: 2,
  class: "text-danger ms-2 fw-bold small"
}
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock-o me-5" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Temps restant", -1))
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "badge bg-info fs-13" }
const _hoisted_20 = {
  class: "progress mb-25",
  style: {"height":"8px"}
}
const _hoisted_21 = { class: "d-flex align-items-start gap-10 mb-15" }
const _hoisted_22 = {
  class: "badge bg-primary rounded-circle d-flex align-items-center justify-content-center",
  style: {"min-width":"30px","height":"30px","font-size":"14px"}
}
const _hoisted_23 = { class: "fw-medium mb-0 fs-15" }
const _hoisted_24 = { class: "ps-40" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["checked", "onChange", "id"]
const _hoisted_28 = ["name", "checked", "onChange", "id"]
const _hoisted_29 = ["for"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = ["value", "onInput"]
const _hoisted_32 = { class: "text-center mt-30" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm me-5" }, null, -1))
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-paper-plane me-8" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_ctx.composition)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_7,
              _createElementVNode("div", {
                class: _normalizeClass(["quiz-header d-flex align-items-center justify-content-between mb-25 p-15 rounded-2 border", _ctx.timerClass]),
                style: {"position":"sticky","top":"70px","z-index":"100","background":"white"}
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.composition.titre), 1),
                  _createElementVNode("small", _hoisted_9, _toDisplayString(_ctx.composition.filiereNiveauMatiere?.matiere?.libelle), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, " Essai " + _toDisplayString(_ctx.composition.tentativesEffectuees + 1) + " / " + _toDisplayString(_ctx.composition.nombreEssaisAutorise), 1),
                    (_ctx.composition.tentativesRestantes > 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (" + _toDisplayString(_ctx.composition.tentativesRestantes) + " restants) ", 1))
                      : (_ctx.composition.tentativesRestantes === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " (" + _toDisplayString(_ctx.composition.tentativesRestantes) + " restant) ", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, " Dernier essai - Seule cette note sera retenue "))
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["fw-bold fs-22", _ctx.timerTextClass])
                  }, [
                    _hoisted_16,
                    _createTextVNode(_toDisplayString(_ctx.timerDisplay), 1)
                  ], 2),
                  _hoisted_17
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.nbRepondu) + " / " + _toDisplayString(_ctx.questions.length) + " répondues ", 1)
                ])
              ], 2),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", {
                  class: "progress-bar bg-success",
                  style: _normalizeStyle({ width: _ctx.progressPercent + '%' }),
                  role: "progressbar"
                }, null, 4)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (compoQ, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: compoQ.question.id,
                  class: "mb-25"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["border rounded-2 p-20", _ctx.estQuestionRepondue(compoQ.question.id) ? 'border-success' : 'border-light'])
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(index + 1), 1),
                      _createElementVNode("p", _hoisted_23, _toDisplayString(compoQ.question.contenu), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      (compoQ.question.propositions && compoQ.question.propositions.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(compoQ.question.propositions, (proposition) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: proposition.id,
                                class: _normalizeClass(["form-check mb-10 p-10 rounded-2 cursor-pointer", _ctx.getPropositionClass(compoQ.question.id, proposition.id)]),
                                onClick: ($event: any) => (_ctx.choisirReponse(compoQ.question.id, proposition.id, compoQ.question.type))
                              }, [
                                (compoQ.question.type === 'QCM')
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      class: "form-check-input",
                                      checked: _ctx.isChecked(compoQ.question.id, proposition.id),
                                      onChange: ($event: any) => (_ctx.choisirReponse(compoQ.question.id, proposition.id, compoQ.question.type)),
                                      id: `q${compoQ.question.id}_p${proposition.id}`
                                    }, null, 40, _hoisted_27))
                                  : (_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      class: "form-check-input",
                                      type: "radio",
                                      name: `question_${compoQ.question.id}`,
                                      checked: _ctx.isChecked(compoQ.question.id, proposition.id),
                                      onChange: ($event: any) => (_ctx.choisirReponse(compoQ.question.id, proposition.id, compoQ.question.type)),
                                      id: `q${compoQ.question.id}_p${proposition.id}`
                                    }, null, 40, _hoisted_28)),
                                _createElementVNode("label", {
                                  class: "form-check-label fw-medium cursor-pointer w-100",
                                  for: `q${compoQ.question.id}_p${proposition.id}`
                                }, _toDisplayString(proposition.contenu), 9, _hoisted_29)
                              ], 10, _hoisted_26))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("textarea", {
                              class: "form-control shadow-none",
                              rows: "5",
                              placeholder: "Rédigez votre réponse ici...",
                              value: _ctx.reponsesTexte.get(compoQ.question.id) || '',
                              onInput: ($event: any) => (_ctx.saisirReponseTexte(compoQ.question.id, ($event.target as HTMLTextAreaElement).value))
                            }, null, 40, _hoisted_31)
                          ]))
                    ])
                  ], 2)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("button", {
                  class: "btn btn-success btn-lg px-40 fw-bold",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmerSoumission && _ctx.confirmerSoumission(...args))),
                  disabled: _ctx.soumissionEnCours
                }, [
                  (_ctx.soumissionEnCours)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                        _hoisted_35,
                        _createTextVNode(" Soumission en cours... ")
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_36, [
                        _hoisted_37,
                        _createTextVNode(" Soumettre mes réponses ")
                      ]))
                ], 8, _hoisted_33)
              ])
            ], 64))
          : _createCommentVNode("", true)
    ])
  ]))
}